<template>
    <div name="modal" class="custom-modal" @click="closeCustomModal()">

        <div class="custom-modal-window" @click.stop>
            <div class="btn-close" @click="closeCustomModal()"></div>

            <div class="custom-modal-body" v-if="fetcher.initialized">

                <div class="container-fluid">
                    <h2 class="mb-6 text-dark" v-if="employee.name == ''">Ny anställd</h2>
                    <h2 class="mb-6 text-dark" v-else>{{ employee.name }}</h2>
                    <div class="row mb-6 employee-info">
                        <div class="col-12 col-sm-5 col-xl-3">
                            <p>
                                <b>Registrerad</b><br>
                                {{ employee.created_at }}
                            </p>
                        </div>
                        <div class="col-12 col-sm-5 col-xl-3">
                            <p>
                                <b>Aktiverad</b><br>
                                {{ employee.activated_at }}
                            </p>
                        </div>
                        <div class="col-12 col-sm-7 col-xl-4">
                            <p>
                                <b>Senaste behandling</b><br>
                                {{ last_treatment_at }}
                            </p>
                        </div>
                        <div class="col-12 col-sm-7 col-xl-4">
                            <p>
                                <b>Antal behandlingar</b><br>
                                {{ num_treatments }} st
                            </p>
                        </div>
                    </div>
                </div>

                <div class="tabs-container">
                    <div class="tab" :class="{active: activeTab === 'info'}" @click="activeTab = 'info'">
                        Uppgifter
                    </div>
                    <div class="tab" :class="{active: activeTab === 'treatments'}" @click="activeTab = 'treatments'" v-if="auth.company_portal_show_treatments">
                        Behandlingar
                    </div>
                </div>

                <modal-info
                    :employee="employee"
                    :dynamic_fields="dynamic_fields"
                    :workplaces="workplaces"
                    v-if="activeTab === 'info'"
                    @close="closeCustomModal"
                />
                <modal-treatments
                    :employee="employee"
                    v-if="activeTab === 'treatments'"
                />

            </div>

            <div class="custom-modal-body loading-employee-placeholder" v-else>

                <div class="container-fluid">

                    <div class="placeholder-glow w-100">
                        <span class="placeholder bg-light col-24 col-lg-12 mb-6 rounded-1 headline"></span>
                    </div>

                    <div class="row mb-6 employee-info">
                        <div class="col-12 col-sm-5 col-xl-3">
                            <div class="placeholder-glow w-100">
                                <span class="placeholder bg-light col-24 rounded-1 paragraph"></span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-5 col-xl-3">
                            <div class="placeholder-glow w-100">
                                <span class="placeholder bg-light col-24 rounded-1 paragraph"></span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-7 col-xl-4">
                            <div class="placeholder-glow w-100">
                                <span class="placeholder bg-light col-24 rounded-1 paragraph"></span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-7 col-xl-4">
                            <div class="placeholder-glow w-100">
                                <span class="placeholder bg-light col-24 rounded-1 paragraph"></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs-container">
                    <div class="tab active">
                        Uppgifter
                    </div>
                    <div class="tab">
                        Behandlingar
                    </div>
                </div>

                <div class="container-fluid tabs-content"></div>

            </div>

        </div>
    </div>
</template>

<script>
import modaler from '../../../shared/mixins/modaler'
import fetcher from '../../../shared/mixins/fetcher'

import modalInfo from './modal-info'
import modalTreatments from './modal-treatments'

export default {

    mixins: [
        modaler,
        fetcher
    ],

    components: {
        modalInfo,
        modalTreatments
    },

    props: {
        employee_id: {
            required: true
        }
    },

    data () {
        return {
            employee: null,
            activeTab: 'info', // info || treatments
            last_treatment_at: null,
            num_treatments: 0,
            workplaces: [],
            dynamic_fields: [],
            fetcher: {
                autoFill: [
                    'employee',
                    'workplaces',
                    'dynamic_fields',
                    'last_treatment_at',
                    'num_treatments'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/data/employees/' + this.employee_id
        }
    }
}
</script>
